import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';
import striptags from 'striptags';

// DEFAULT LIST PAGE
const queer50List = (state = {}, action = {}) => {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const rss = `/rss`;
  const seoTitle = get(action, 'queer50.acf.title');
  const pageTitle = get(action, 'queer50.title.rendered');
  const defaultTitle = 'Announcing Fast Company’s second annual Queer 50 list';
  const pageExcerpt = get(action, 'queer50.excerpt.rendered');
  const defaultExcerpt =
    'The second annual list of LGBTQ women and nonbinary innovators in business and tech';
  const pageImage = get(
    action,
    'queer50._embedded.wp:featuredmedia[0].source_url'
  );
  const franchiseImage = get(
    action,
    'queer50.acf.franchise_images.franchise_hero_image_desktop'
  );
  const defaultImage =
    'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/05/Fast_Company-Final_v02-copy2.jpg';

  const base = {
    site,
    siteConf,
    title: seoTitle || pageTitle || defaultTitle,
    url: `https://www.${site}.com/queer-50/list`,
    description: striptags(pageExcerpt) || defaultExcerpt,
    image: pageImage || franchiseImage || defaultImage,
    articleSection: '',
    rss,
    config: state.config,
    extend: [
      {
        link: []
      }
    ]
  };

  return baseSeoUtil(base);
};

// INDIVIDUAL LIST ITEM PAGE
const queer50Item = (state = {}, action = {}) => {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const rss = `/rss`;
  const pageExcerpt = get(action, 'queer50.excerpt.rendered');
  const defaultExcerpt =
    'The second annual list of LGBTQ women and nonbinary innovators in business and tech';
  const itemRank = get(action, 'queer50.itemRank');
  const thisItem = get(
    action,
    `queer50.externalList.list.records[${parseInt(itemRank, 10) - 1}]`
  );
  const title = `${thisItem.fields.Name} is No. ${
    thisItem.fields.Rank
  } on the 2022 Fast Company Queer 50 list`;
  const pageImage = get(
    action,
    'queer50._embedded.wp:featuredmedia[0].source_url'
  );
  const franchiseImage = get(
    action,
    'queer50.acf.franchise_images.franchise_hero_image_desktop'
  );
  const defaultImage =
    'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/05/Fast_Company-Final_v02-copy2.jpg';

  const base = {
    site,
    siteConf,
    title,
    url: itemRank
      ? `https://www.${site}.com/queer-50/list/rank/${itemRank}`
      : `https://www.${site}.com/queer-50/list`,
    description: striptags(pageExcerpt) || defaultExcerpt,
    image: pageImage || franchiseImage || defaultImage,
    articleSection: '',
    rss,
    config: state.config,
    extend: [
      {
        link: []
      }
    ]
  };

  return baseSeoUtil(base);
};

// INITIAL FRANCHISE YEAR LOGIC - 2021
const queer50Initial = (state = {}) => {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const description =
    'The second annual list of LGBTQ women and nonbinary innovators in business and tech';
  const title = 'Announcing Fast Company’s second annual Queer 50 list';
  const rss = `/rss`;

  const base = {
    site,
    siteConf,
    title,
    url: `https://www.${site}.com/queer-50/2021`,
    description,
    image:
      'https://assets.fastcompany.com/image/upload/v1590670864/wp-cms/uploads/2020/05/FC-Q50-LogoAnim_16x9_still.png',
    articleSection: '',
    rss,
    config: state.config,
    extend: [
      {
        link: []
      }
    ]
  };

  return baseSeoUtil(base);
};

export { queer50List, queer50Item, queer50Initial };
